import React, { forwardRef } from "react";
import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { Icon } from "../Icon";
import { StyledIconButton } from "./IconButton.styled";
import Tooltip, { TooltipProps } from "../Tooltip";

export interface IconButtonProps
  extends Omit<MuiIconButtonProps, "type" | "size"> {
  title?: string;
  //TODO: UNSAFE_transparent is used to keep old transparent styles in many places
  // in Clipro and DS, it's prohibited to use it, will be replaced in next versions,
  // please use variant="transparent" instead.
  type?: "warning" | "primary" | "secondary" | "UNSAFE_transparent";
  variant?: "full" | "transparent";
  size?: "small" | "medium" | "big";
  shape?: "square" | "round";
  /* The name should be taken from: https://fonts.google.com/icons */
  name: string;
  isFill?: boolean;
  isSelected?: boolean;
  tooltipProps?: Omit<TooltipProps, "children">;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      title,
      name,
      size = "medium",
      type = "primary",
      shape = "square",
      variant = "full",
      isFill = false,
      isSelected = false,
      tooltipProps,
      ...rest
    },
    ref,
  ) => {
    return (
      <Tooltip {...tooltipProps}>
        <span>
          <StyledIconButton
            ref={ref}
            iconButtonType={type}
            shape={shape}
            iconButtonSize={size}
            iconButtonVariant={variant}
            disableRipple
            isSelected={isSelected}
            title={title}
            {...rest}
          >
            <Icon name={name} size={size} isFill={isFill} />
          </StyledIconButton>
        </span>
      </Tooltip>
    );
  },
);

export default IconButton;
